import { GenericTestRouteState } from './generic-test-state'

export const PfeifferTestRouteState = GenericTestRouteState.named(
  'PfeifferTestRouteState'
)
